import { useEffect, useState } from 'react'
import { useRightPanel } from '@/containers/SubscriptionFormPageNew/Components/shared/RightPanel/rightPanelContext'

const storageKey = (moduleKey: string) => `hop-sidebar-module-${moduleKey}`

const readStored = (key: string): boolean | null => {
  try {
    const stored: unknown = JSON.parse(window.localStorage.getItem(key) ?? 'null')
    return typeof stored === 'boolean' ? stored : null
  } catch {
    return null
  }
}

const writeStored = (key: string, expanded: boolean) => {
  try {
    window.localStorage.setItem(key, JSON.stringify(expanded))
  } catch {
    // Private browsing or full storage: the choice only lasts for the session.
  }
}

const useModuleCollapse = (moduleKey: string) => {
  const key = storageKey(moduleKey)
  const panel = useRightPanel()
  const [stored, setStored] = useState(() => readStored(key) ?? true)

  const remember = (next: boolean) => {
    setStored(next)
    writeStored(key, next)
  }

  const toggle = () => remember(!stored)

  const pendingRequestId =
    panel.request?.key === moduleKey && panel.request.id !== panel.handledRequestId ? panel.request.id : null

  useEffect(() => {
    if (pendingRequestId === null) return
    remember(true)
    panel.markRequestHandled(pendingRequestId)
  }, [pendingRequestId])

  return { expanded: panel.expanded && stored, toggle, panelExpanded: panel.expanded }
}

export default useModuleCollapse
